"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.filteredCollections = void 0;
const filteredCollections = (target, selected, filteredFn, compareFn) => {
    const newCollections = filteredFn(target, selected);
    return typeof compareFn === 'function' ? newCollections.sort(compareFn) : newCollections;
};
exports.filteredCollections = filteredCollections;
//# sourceMappingURL=filteredCollections.js.map